import { NavLink } from 'react-router-dom';
import { COLOURS_LIGHT, LINE_HEIGHT_REGULAR } from '../providers/designSystem';

const List = ({ children }) => {
    return (
        <ul
            style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: `16px`,
                paddingTop: `12px`,
                paddingBottom: `12px`,
            }}
        >
            {children}
        </ul>
    );
};
const ListItem = ({ children }) => {
    return (
        <li
            style={{
                color: `${COLOURS_LIGHT.grey}`,
                fontSize: `12px`,
                lineHeight: `${LINE_HEIGHT_REGULAR}`,
            }}
        >
            {children}
        </li>
    );
};
export const Navigation = () => {
    return (
        <nav className="content">
            <List>
                <ListItem>
                    <NavLink to="/">Home</NavLink>
                </ListItem>

                <ListItem>
                    <NavLink to="/colour-palettes">Colour Palettes</NavLink>
                </ListItem>

                <ListItem>
                    <NavLink to="/colours">Colours</NavLink>
                </ListItem>
            </List>
        </nav>
    );
};
